(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

jQuery(document).ready(function () {

  //travel trailer data = model=1&length=30&floorplan=30rb&decor=cognac_maple_macadamia&options=281,635&customer=Testing-User&zip=46659&email=testing@user.com
  //touring coach data = model=1&color=id&floorplan=slug&decor=slug&options=id&customer=Testing-User&zip=46659&email=testing@user.com
  var configData = {};
  try {
    var data = JSON.parse(localStorage.getItem('configData'));
    if (data) {
      configData = data;
    }
  } catch (e) {}

  if (!configData.email) {
    configData.firstName = '';
    configData.lastName = '';
    configData.email = '';
  }

  if (!configData.zip) {
    configData.zip = '';
  }

  jQuery('.model-card').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    var redirect = jQuery(this).find('a.btn-begin').attr('href');

    var productId = jQuery(this).attr('prod-id'),
        productName = jQuery(this).attr('prod-name');
    productImg = jQuery(this).find('.pl-gbImg').find('img').attr('src');

    configData.model = productId;
    configData.modelName = productName;
    configData.productImage = productImg;
    configData.configType = 'tc';

    sessionStorage.setItem('configData', JSON.stringify(configData));
    localStorage.setItem('configData', JSON.stringify(configData));

    var retUrl = redirect + buildURLParams();
    var seenForm = getCookie('tc_form');

    // if (!seenForm || configData.email === '' || configData.zip === '') {
    //    $('.pl-form-modal').fadeIn();
    //    $('.pl-form-modal').attr('return-url', retUrl);
    // } else {
    // }
    window.location.href = retUrl;
  });

  var currentParams = location.href.split('?')[1];
  var urlVariables = currentParams.split('&');
  var storedOptions;

  for (i = 0; i < urlVariables.length; i++) {
    var varName = urlVariables[i].split('=');
    if (varName[0] == 'options') {
      storedOptions = varName[1].split(',');
    }
  }

  //remove options from variables to rebuild with potentially removed IDs
  urlVariables.pop();

  $('.pl-remove-selected-color').click(function (e) {
    e.preventDefault();
    var configData = JSON.parse(sessionStorage.getItem('configData'));
    var defaultColor = $(this).attr('default-color'),
        defaultColorHex = $(this).attr('default-color-hex'),
        defaultColorImg = $(this).attr('default-color-model');
    $('#exteriorShot').attr('src', defaultColorImg);
    $(this).parent().siblings('.pl-row-label').text(defaultColor);
    $('#color-swatch').css('background', defaultColorHex);
    $(this).siblings('.pl-row-price').text('Included');
    $(this).css('visibility', 'hidden');
    configData.color = 0;
    sessionStorage.setItem('configData', JSON.stringify(configData));
    $('#color-price').text('Included');
    var currentMSRP = Number($('#msrp').text().replace(/[^0-9.-]+/g, ""));
    var colorPrice = $(this).siblings('.pl-row-price').attr('raw');
    $('#msrp').text('$' + (currentMSRP - colorPrice).toLocaleString(undefined, { minimumFractionDigits: 0 }));

    $('.btn-finish').attr('href', '/configurator/tc/complete/' + buildURLParams());
  });

  $('.pl-remove-selected-option').click(function (e) {
    e.preventDefault();
    var optionToRemove = $(this).attr('option-id');
    var configData = JSON.parse(sessionStorage.getItem('configData'));

    var arrIndex = $.inArray(optionToRemove, storedOptions);

    if (arrIndex !== -1) {
      storedOptions.splice(arrIndex, 1);
    }

    var localOptions = configData.options.split(',');
    localOptions.splice($.inArray(optionToRemove, localOptions), 1);

    $(this).parent().parent('.pl-row').remove();
    $('#option-' + optionToRemove + '-image').remove();

    var removedOptionPrice = Number($(this).siblings('.pl-row-price').text().replace(/[^0-9.-]+/g, ""));
    var currentOptionsTotal = Number($('#options-price').text().replace(/[^0-9.-]+/g, ""));
    var currentMSRP = Number($('#msrp').text().replace(/[^0-9.-]+/g, ""));

    $('#options-price').text("$" + (currentOptionsTotal - removedOptionPrice).toLocaleString(undefined, { minimumFractionDigits: 0 }));
    $("#msrp").text("$" + (currentMSRP - removedOptionPrice).toLocaleString(undefined, { minimumFractionDigits: 0 }));

    configData.options = localOptions.join();
    sessionStorage.setItem('configData', JSON.stringify(configData));

    jQuery('.btn-finish').attr('href', '/configurator/tc/complete/' + buildURLParams());
  });

  jQuery('.btn-finish').attr('href', '/configurator/tc/complete/' + buildURLParams());

  jQuery('.nav-link').click(function (e) {
    if (jQuery(this).hasClass('showExterior')) {
      jQuery('#exteriorShot').show();
      jQuery('#interiorShot').hide();
    } else {
      jQuery('#interiorShot').show();
      jQuery('#exteriorShot').hide();
    }
  });
});

},{}]},{},[1]);
